import { useDispatch, useSelector } from "react-redux";
import { setProfil, setWait } from "../redux";

export const useLogin = () => {
    const dispatch = useDispatch();
    const wait = useSelector(state => state.site.wait);

    const postLogin = async (email, password, save) => {
        if (wait > 0) return
        dispatch(setWait(1));
        
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        })
        const res = await req.json();
        dispatch(setWait(-1));

        if (req.status !== 200) {
            localStorage.removeItem('save_login');
            sessionStorage.removeItem('token');
            localStorage.removeItem('token');
            return
        }

        const { token, ...resFiltered } = res;

        if (save) {
            localStorage.setItem('token', token);
            localStorage.setItem('save_login', 'true');
        }
        sessionStorage.setItem('token', token);
        dispatch(setProfil(resFiltered));
    }
    return postLogin;
};